export default {
      id: "logo-lg-usage",
      viewBox: "0 0 182 45",
      url: __webpack_public_path__ + "svgsprite.svg#logo-lg",
      toString: function () {
        return this.url;
      }
    }